// src/components/pagos/MercadoPagoCheckout.js
import React, { useState, useEffect } from 'react';
import { initMercadoPago, Wallet } from '@mercadopago/sdk-react';
import api from '../../services/api';

const MercadoPagoCheckout = ({ plan, onSuccess, onError }) => {
  const [preferenceId, setPreferenceId] = useState(null);
  const [qrCode, setQrCode] = useState(null);
  const [metodo, setMetodo] = useState('pix');
  const [cargando, setCargando] = useState(false);
  const [mpInicializado, setMpInicializado] = useState(false);

  // Inicializar Mercado Pago UNA SOLA VEZ
  useEffect(() => {
    try {
      initMercadoPago(process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY);
      setMpInicializado(true);
      console.log('✅ Mercado Pago inicializado');
    } catch (error) {
      console.error('❌ Error inicializando Mercado Pago:', error);
    }
  }, []);

  const handleGenerarPago = async () => {
    setCargando(true);
    try {
      const response = await api.post('/mercadopago/crear-preferencia', {
        planId: plan.id,
        metodoPago: metodo
      });

      const data = response.data;

      if (data.success) {
        if (data.metodo === 'pix') {
          setQrCode({
            qr: data.qrCodeBase64,
            codigo: data.qrCode,
            url: data.ticketUrl
          });
        } else {
          setPreferenceId(data.preferenceId);
        }
      } else {
        onError?.(data.error);
      }
    } catch (error) {
      console.error('Error:', error);
      onError?.(error.message);
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="mp-checkout">
      <h3>💵 Pago con Mercado Pago</h3>
      
      <div className="mp-metodos">
        <label>
          <input
            type="radio"
            value="pix"
            checked={metodo === 'pix'}
            onChange={(e) => setMetodo(e.target.value)}
          />
          <span>PIX (QR Code - pago inmediato)</span>
        </label>
        
        <label>
          <input
            type="radio"
            value="checkout"
            checked={metodo === 'checkout'}
            onChange={(e) => setMetodo(e.target.value)}
          />
          <span>Tarjeta / Otros métodos</span>
        </label>
      </div>

      {!preferenceId && !qrCode && (
        <button 
          onClick={handleGenerarPago}
          disabled={cargando || !mpInicializado}
          className="btn-mp"
        >
          {cargando ? 'Generando...' : 'Pagar con Mercado Pago'}
        </button>
      )}

      {qrCode && (
        <div className="mp-pix">
          <h4>🔷 Escanea el código QR</h4>
          <img 
            src={`data:image/png;base64,${qrCode.qr}`} 
            alt="QR Code PIX"
            className="pix-qr"
          />
          <p>O copia el código PIX:</p>
          <div className="pix-codigo">
            <code>{qrCode.codigo}</code>
            <button onClick={() => navigator.clipboard.writeText(qrCode.codigo)}>
              📋 Copiar
            </button>
          </div>
          <p className="pix-expira">⏰ Expira en 30 minutos</p>
          <button onClick={() => window.open(qrCode.url, '_blank')}>
            Ver en Mercado Pago
          </button>
        </div>
      )}

      {preferenceId && (
        <div className="mp-wallet">
          <Wallet 
            initialization={{ preferenceId }}
            customization={{ texts: { valueProp: 'smart' } }}
          />
        </div>
      )}
    </div>
  );
};

export default MercadoPagoCheckout;